export default [{"url":"https://demo-0.api.invexerp.io","name":"Branch 1","port":"6515","isStore":true,"isHQ":true}]